/** @jsxImportSource @emotion/react */
import React, { memo } from 'react'
import { AnimatePresence } from 'framer-motion'
import { ScrollButton, ScrollButtonProps, motionStyled } from './styles'

const MotionScrollButton = motionStyled<ScrollButtonProps>(ScrollButton)

interface ScrollButtonsProps {
  scrollToTop: () => void
  scrollToBottom: () => void
  canScroll: boolean
  isAtTop: boolean
  isAtBottom: boolean
}

const ScrollButtons = memo(
  ({
    scrollToTop,
    scrollToBottom,
    canScroll,
    isAtTop,
    isAtBottom
  }: ScrollButtonsProps) => {
    // Removed console.log for performance
    return (
      <>
        {/* Top scroll button */}
        <AnimatePresence mode="wait">
          {canScroll && !isAtTop && (
            <MotionScrollButton
              key="scroll-top"
              $position="top"
              onClick={scrollToTop}
              title="Scroll to top"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }}
            >
              ↑
            </MotionScrollButton>
          )}
        </AnimatePresence>

        {/* Bottom scroll button */}
        <AnimatePresence mode="wait">
          {canScroll && !isAtBottom && (
            <MotionScrollButton
              key="scroll-bottom"
              $position="bottom"
              onClick={scrollToBottom}
              title="Scroll to bottom"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }}
            >
              ↓
            </MotionScrollButton>
          )}
        </AnimatePresence>
      </>
    )
  }
)

ScrollButtons.displayName = 'ScrollButtons'

export default ScrollButtons
